import './TagGroup.64fa984344b81446c8ff31622a6fe8ac.css';
export default {"tagGroup":"_tagGroup_zkfoy_1","large":"_large_zkfoy_1"};